import React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { Typography, Stack } from '@mui/material';
import { status } from '../../../../theme/muiTheme';

const EnergiesPieChart = ({ reportData, subReportGroupSelection }) => {
  // Only process data from the selected group, or all groups if no selection
  const dataToProcess = subReportGroupSelection && reportData.SubReports[subReportGroupSelection]
    ? [reportData.SubReports[subReportGroupSelection]]  // Only selected group
    : Object.values(reportData.SubReports);             // All groups (fallback)

  // Process and format data for MUI PieChart
  const formattedData = dataToProcess.flatMap(group =>
    group.map(oneMeasurementPoint => {
      console.log("oneMeasurementPoint in EnergiesPieChart: ", oneMeasurementPoint);
      let total = 0;
      Object.values(oneMeasurementPoint.Values).forEach(value => {
        total += value;
      });
      return {
        name: oneMeasurementPoint.Label + " (" + oneMeasurementPoint.HwId + ")",
        valueName: oneMeasurementPoint.ValueName,
        value: total,
        unit: oneMeasurementPoint.Unit
      };
    })
  ).sort((a, b) => b.value - a.value); // sort high -> low

  // Generate colors from red (highest) to green (lowest) with quick transition
  const generateColor = (index, total) => {
    if (total === 1) return status.errorLight; // Single item, use red

    // Calculate ratio with quicker transition (0 = highest value/red, 1 = lowest value/green)
    const linearRatio = index / (total - 1);
    const ratio = Math.pow(linearRatio, 0.6); // Power function for quicker transition

    // Interpolate between red and green
    const red = Math.round(255 * (1 - ratio) + 68 * ratio);   // 255 -> 68
    const green = Math.round(68 * (1 - ratio) + 255 * ratio); // 68 -> 255  
    const blue = 68; // Keep blue constant for red-green gradient

    return `rgb(${red}, ${green}, ${blue})`;
  };

  // Format data for MUI PieChart (requires id, value, and label)
  const pieChartData = formattedData.map((item, index) => ({
    id: index,
    value: item.value,
    label: `${item.name} [${item.value.toFixed(1)} ${item.unit}]`,
    name: item.name,
    unit: item.unit,
    color: generateColor(index, formattedData.length)
  }));

  return (
    <PieChart
      series={[
        {
          data: pieChartData,
          highlightScope: { fade: 'global', highlight: 'item' },
          faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
          valueFormatter: (value) => `${value.value?.toFixed(1) || value.toFixed(1)}`,
          arcLabel: (item) => `${item.value} ${item.unit}`,
          arcLabelMinAngle: 50,
          arcLabelRadius: '50%',
          // outerRadius: 100,
          paddingAngle: 0,
          cornerRadius: 2,
          startAngle: -35,
          endAngle: 325,
        }
      ]}
      height={400}
      width={600}
      margin={{ top: 40, bottom: 40, left: 40, right: 40 }}
      slotProps={{
        legend: {
          direction: 'column',
          position: { vertical: 'middle', horizontal: 'right' },
          padding: 0,
        },
      }}
    />
  );
};

export default EnergiesPieChart;


